import React from 'react';
import { SVGProps } from './type';

const IconPen = ({ fill }: SVGProps) => (
  <g
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4172 5.52976C14.6981 4.81058 13.5275 4.82558 12.827 5.56296L5.04738 13.752C4.82131 13.99 4.66426 14.285 4.59306 14.6054L4.04428 17.0749C3.7607 18.351 4.88282 19.4972 6.16464 19.2409L9.05658 18.6625C9.40673 18.5924 9.72831 18.4203 9.98081 18.1678L17.7391 10.4095C18.4455 9.70319 18.4455 8.55798 17.7391 7.85163L15.4172 5.52976ZM14.1383 6.80871L16.4602 9.13058L8.70186 16.8889L5.80992 17.4673L6.3587 14.9978L14.1383 6.80871ZM13.6695 17.722C13.17 17.722 12.7651 18.1269 12.7651 18.6263C12.7651 19.1258 13.17 19.5307 13.6695 19.5307H19.0956C19.5951 19.5307 20 19.1258 20 18.6263C20 18.1269 19.5951 17.722 19.0956 17.722H13.6695Z"
      fill={fill}
    />
  </g>
);

export default IconPen;
